<template>
  <div class="menus-selection-view">
    <h1 class="mb-4">Gestión de Menús</h1>
    
    <div class="row">
      <div class="col-md-3 mb-4">
        <div class="card h-100 style-card">
          <div class="card-body">
            <h5 class="card-title">Estilo 1: Tabla Avanzada</h5>
            <p class="card-text">Una tabla mejorada con ordenamiento por columnas, filtrado y exportación a Excel.</p>
            <img src="https://via.placeholder.com/300x150?text=Tabla+Avanzada" class="img-fluid mb-3 rounded" alt="Tabla Avanzada">
            <div class="d-grid">
              <router-link to="/menus-table1" class="btn btn-primary">Seleccionar</router-link>
            </div>
          </div>
        </div>
      </div>
      
      <div class="col-md-3 mb-4">
        <div class="card h-100 style-card">
          <div class="card-body">
            <h5 class="card-title">Estilo 2: Vista de Tarjetas</h5>
            <p class="card-text">Visualización de menús en formato de tarjetas con información detallada.</p>
            <img src="https://via.placeholder.com/300x150?text=Vista+Tarjetas" class="img-fluid mb-3 rounded" alt="Vista de Tarjetas">
            <div class="d-grid">
              <router-link to="/menus-table2" class="btn btn-primary">Seleccionar</router-link>
            </div>
          </div>
        </div>
      </div>
      
      <div class="col-md-3 mb-4">
        <div class="card h-100 style-card">
          <div class="card-body">
            <h5 class="card-title">Estilo 3: Vista Jerárquica</h5>
            <p class="card-text">Visualización jerárquica de menús con estructura de árbol y vista detallada.</p>
            <img src="https://via.placeholder.com/300x150?text=Vista+Jerárquica" class="img-fluid mb-3 rounded" alt="Vista Jerárquica">
            <div class="d-grid">
              <router-link to="/menus-table3" class="btn btn-primary">Seleccionar</router-link>
            </div>
          </div>
        </div>
      </div>
      
      <div class="col-md-3 mb-4">
        <div class="card h-100 style-card highlight-card">
          <div class="card-body">
            <div class="ribbon"><span>Nuevo</span></div>
            <h5 class="card-title">Estilo 4: Vue Good Table</h5>
            <p class="card-text">Tabla profesional con paginación, búsqueda avanzada, filtros por columna y exportación.</p>
            <img src="https://via.placeholder.com/300x150?text=Vue+Good+Table" class="img-fluid mb-3 rounded" alt="Vue Good Table">
            <div class="d-grid">
              <router-link to="/menus-table4" class="btn btn-success">Seleccionar</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="card mt-3">
      <div class="card-body">
        <h5 class="card-title">Vista Actual</h5>
        <p class="card-text">Si prefieres seguir usando la vista actual de menús, puedes acceder a ella desde el siguiente enlace:</p>
        <router-link to="/menus" class="btn btn-outline-primary">Vista Actual</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { useAccessControl } from '@/composables/useAccessControl'

export default {
  name: 'MenusSelectionView',
  setup() {
    const { requiresAuth, requiresMenuPermission } = useAccessControl({
      requiresAuth: true,
      requiresMenuPermission: true
    })

    return {
      requiresAuth,
      requiresMenuPermission
    }
  }
}
</script>

<style scoped>
.menus-selection-view {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

.style-card {
  transition: all 0.3s ease;
  border: 1px solid #dee2e6;
  position: relative;
  overflow: hidden;
}

.style-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  border-color: #007bff;
}

.highlight-card {
  border-color: #28a745;
  box-shadow: 0 5px 15px rgba(40, 167, 69, 0.2);
}

.highlight-card:hover {
  border-color: #28a745;
  box-shadow: 0 10px 20px rgba(40, 167, 69, 0.3);
}

/* Ribbon style */
.ribbon {
  position: absolute;
  right: -5px;
  top: -5px;
  z-index: 1;
  overflow: hidden;
  width: 75px;
  height: 75px;
  text-align: right;
}

.ribbon span {
  font-size: 10px;
  font-weight: bold;
  color: #fff;
  text-transform: uppercase;
  text-align: center;
  line-height: 20px;
  transform: rotate(45deg);
  width: 100px;
  display: block;
  background: #28a745;
  box-shadow: 0 3px 10px -5px rgba(0, 0, 0, 1);
  position: absolute;
  top: 19px;
  right: -21px;
}

.ribbon span::before {
  content: "";
  position: absolute;
  left: 0px;
  top: 100%;
  z-index: -1;
  border-left: 3px solid #1e7e34;
  border-right: 3px solid transparent;
  border-bottom: 3px solid transparent;
  border-top: 3px solid #1e7e34;
}

.ribbon span::after {
  content: "";
  position: absolute;
  right: 0px;
  top: 100%;
  z-index: -1;
  border-left: 3px solid transparent;
  border-right: 3px solid #1e7e34;
  border-bottom: 3px solid transparent;
  border-top: 3px solid #1e7e34;
}
</style>
